<template>
  <div>
    <div class="columns">
      <div class="column">
        <h1 class="title">Purchase additional reviews</h1>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <p class="has-text-left">Purchase additional reviews to continue accessing customer data</p>
        <p class="has-text-left">Each additional review costs <strong>R{{ reviewCost }}</strong> on your {{subscription_name}} package</p>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <span class="sub is-size-7">Amount of additional reviews to be purchased</span>
        <div class="columns">
          <div class="column is-paddingless is-2-desktop">
            <div class="field">
              <div class="control">
                <input :disabled="is_loading" class="input" type="text" name="review_count" v-model="review_count" placeholder="Number of reviews" />
              </div>
            </div>
          </div>
          <div class="column is-paddingless">
            <div class="field">
              <div class="control">
                <p class="has-text-left has-text-weight-bold multiplier">R{{ reviewMultiplier }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <span class="info-display has-text-weight-semibold is-size-6 margin-top-20">Payment method</span>
          <div>
            <label class="radio is-size-6 label-filters">
              <input :disabled="is_loading" type="radio" name="payment_method" value="CREDIT_CARD" v-model="form.payment_method" />&nbsp;&nbsp;&nbsp;Credit Card
            </label>
          </div>
          <div>
            <label class="radio is-size-6 label-filters">
              <input :disabled="is_loading" type="radio" name="payment_method" value="EFT" v-model="form.payment_method" />&nbsp;&nbsp;&nbsp;EFT
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4-tablet is-3-desktop is-hidden-mobile">
        <button :disabled="!enablePurchaseButton" :class="['button is-button-blue is-fullwidth', { 'is-loading':is_loading }]" @click.prevent="purchaseButtonClicked">PURCHASE REVIEWS</button>
      </div>
      <div class="column is-hidden-tablet">
        <button :disabled="!enablePurchaseButton" :class="['button is-button-blue is-fullwidth', { 'is-loading':is_loading }]" @click.prevent="purchaseButtonClicked">PURCHASE REVIEWS</button>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-undef */

  import axios from 'axios'
  import ApiResource from './../../api/ApiResource.js'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Purchase additional reviews'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Purchase additional reviews'
      })
    },
    name: 'PurchaseAdditionalReviews',
    data () {
      return {
        is_loading: false,
        enablePurchaseButton: false,
        reviewCost: '0.00',
        reviewMultiplier: '0.00',
        review_count: 1,
        subscription_name: '',
        form: new ApiResource({
          payment_method: 'CREDIT_CARD',
          review_count: 1,
          business_id: ''
        })
      }
    },
    created () {
      this.getSubscriptionReviewUnitCost()
    },
    watch: {
      review_count () {
        this.form.review_count = this.review_count
        try {
          const t = parseInt(this.review_count)
          // TODO: add better validation to allow only integer input
          if (isNaN(t)) {
            this.enablePurchaseButton = false
            this.reviewMultiplier = '0.00'
          } else {
            this.reviewMultiplier = (t * parseFloat(this.reviewCost)).toFixed(2)
            this.enablePurchaseButton = true
          }
        } catch (e) {
          this.enablePurchaseButton = false
          console.log('e', e)
        }
      }
    },
    methods: {
      purchaseButtonClicked () {
        this.is_loading = true
        this.form.business_id = localStorage.getItem('org_id')
        this.form.send(`/subscriptions/purchase-reviews`)
          .then((response) => {
            this.is_loading = false
            const invoice = response.invoice
            const paymentMethod = invoice.payment_method === 'EFT' ? 'eft' : 'card'
            this.$router.push(`/purchase-reviews/${paymentMethod}/${invoice.id}/`)
          })
          .catch(() => {
            this.is_loading = false
            const errMessage = this.form.errors.getDefaultErrorMessage()
            flash(errMessage, 'is-danger')
          })
      },
      getSubscriptionReviewUnitCost () {
        this.is_loading = true
        const businessSlug = localStorage.getItem('org_slug')
        axios.get(`/subscriptions/${businessSlug}/adhoc-review-cost`)
          .then((response) => {
            this.reviewCost = this.reviewMultiplier = response.data.cost
            this.enablePurchaseButton = true
            this.subscription_name = response.data.subscription_name
            this.is_loading = false
          })
          .catch((error) => {
            console.log('error', error)
            this.is_loading = false
          })
      }
    }
  }
</script>
<style scoped>

  span.sub {
    margin: 0 0 5px 0;
    display: block;
  }

  .multiplier {
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-top: calc(0.375em - 1px);
    padding-left: 20px;
  }

  .label-filters {
    color: #58595b;
  }
</style>



// WEBPACK FOOTER //
// src/pages/billing/PurchaseAdditionalReviews.vue